import {
  Dropdown,
  PaginatedDropdownList,
  ProductsCategoriesListListData,
  productsCategoriesListListInfiniteOptions,
  UsersListListData,
  usersListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect, RangePickerFilter } from '@crm/components'
import { formatDate } from '@crm/utils'
import { Text } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { DATE_FORMAT, getDaysRangeDate } from '@shared/utils'
import { Flex, Popover, Segmented } from 'antd'
import dayjs from 'dayjs'
import { Calendar } from 'iconsax-react'
import { useEffect, useState } from 'react'

const QUARTER = 90
const YEAR = 365
const MONTH = dayjs().daysInMonth()

export const ReportProductsFilter = () => {
  const { t } = useLocales()
  const { params, updateQuery } = useQueryUpdate()
  const [selectedFilter, setSelectedFilter] = useState<number | string>(
    dayjs().daysInMonth()
  )

  const dateFrom = formatDate(params?.date_from, DATE_FORMAT)

  const dateTo = formatDate(params?.date_to, DATE_FORMAT)

  const dateRangeLabel =
    selectedFilter === 'period' && dateFrom && dateTo
      ? `${dateFrom} - ${dateTo}`
      : t('filter.period')

  useEffect(() => {
    if (!params?.date_from || !params?.date_to) {
      const { dateFrom, dateTo } = getDaysRangeDate(MONTH)
      updateQuery({ date_from: dateFrom, date_to: dateTo }, true)
      setSelectedFilter(MONTH)
    }
  }, [])

  const chartFilterOptions = [
    {
      label: (
        <Popover
          trigger={['click']}
          content={
            <RangePickerFilter
              fromParam="date_from"
              toParam="date_to"
              placeholder={[t('filter.date_from'), t('filter.date_to')]}
            />
          }
          placement="bottom"
        >
          <Flex align="center" justify="center" gap={8}>
            <Calendar size={16} />
            <Text>{dateRangeLabel}</Text>
          </Flex>
        </Popover>
      ),
      value: 'period'
    },
    { label: t('filter.month'), value: MONTH },
    { label: t('filter.quarter'), value: QUARTER },
    { label: t('filter.year'), value: YEAR }
  ]

  const onChangeSegmentValue = (value: number | string) => {
    setSelectedFilter(value)

    if (value === 'period') return

    const { dateFrom, dateTo } = getDaysRangeDate(value as number)
    updateQuery({ date_from: dateFrom, date_to: dateTo })
  }

  return (
    <Flex align="center" gap={10}>
      <InfiniteSelect<
        ProductsCategoriesListListData,
        PaginatedDropdownList,
        Dropdown
      >
        value={params.category ? Number(params.category) : undefined}
        className="select-min-width"
        popupMatchSelectWidth
        placeholder={t('nomenclature.category')}
        getQueryFunction={productsCategoriesListListInfiniteOptions}
        onChange={(category) => updateQuery({ category })}
      />

      <InfiniteSelect<UsersListListData, PaginatedDropdownList, Dropdown>
        getQueryFunction={usersListListInfiniteOptions}
        placeholder={t('contracts.owner')}
        onChange={(owner) => updateQuery({ owner })}
        className="select-min-width"
      />

      <Segmented
        options={chartFilterOptions}
        onChange={onChangeSegmentValue}
        value={selectedFilter}
      />
    </Flex>
  )
}
